import { Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";

import { TranslateModule } from "@ngx-translate/core";

import { NavigationService } from "@/app/core/services/navigation.service";
import { LayoutStore } from "@/app/core/state/layout.store";
import { ButtonComponent } from "@/app/shared/components/button/button.component";

/**
 * NotFoundComponent renders the 404 "Not Found" page.
 * Provides a back navigation option and applies theme via LayoutStore.
 */
@Component({
  selector: "app-not-found",
  imports: [RouterModule, TranslateModule, ButtonComponent],
  templateUrl: "./not-found.component.html",
})
export class NotFoundComponent {
  navigationService = inject(NavigationService);

  randomSuffix = Math.floor(Math.random() * 10000); // To avoid cache, yes we want more and more kitties

  constructor() {
    inject(LayoutStore); // Needed to apply theme
  }
}
